// extracted by mini-css-extract-plugin
module.exports = {"layout":"App_layout__1LipR","footer":"App_footer__29Fsv","mobilemsg":"App_mobilemsg__3y2Er"};